import {BlockItemDrawProps} from "../FrameBlockItem";
import {ClickableFace} from "./ClickableFace";
import {lineBlueHeavy} from "../../../const";

// ThresholdFace is the sill under the door. Nothing is drawn on it: the door face shows
// the threshold dimension. It keeps a near-transparent fill so the cell takes a click
// for debugging.
export class ThresholdFace extends ClickableFace {
    constructor() {
        super((props: BlockItemDrawProps) => {
            const g = props.graphics;
            g.clear();

            const left = Math.min(props.startX, props.endX);
            const right = Math.max(props.startX, props.endX);
            const top = Math.min(props.startY, props.endY);
            const bottom = Math.max(props.startY, props.endY);

            const w = right - left;
            const h = bottom - top;
            if (w <= 0 || h <= 0) return;

            g.beginFill(lineBlueHeavy, 0.001);
            g.drawRect(left, top, w, h);
            g.endFill();
        });
    }
}
